// Libraries
var React = require('react');

class RawJsonModule extends React.Component {
	render() {

		var dataObj = this.props.data;

		return (
			<pre id="json">{JSON.stringify(dataObj, null, 2)}</pre>
		)
	}
}

module.exports = RawJsonModule;


// WEBPACK FOOTER //
// ./src/common/RawJson/RawJsonModule.js